export default {
  // notary list
  notary_list: [],
  notary_details: {},
  filter_loading: false,
  reset_loading: false,
  notaryReady: false,

  // compliance questionnaire
  session_recording_status: false,
  compliance_questionnaire: [],
  compliance_questionnaire_loading: false,
  compliance_response_loading: false,

  //notary loaders
  cancel_loading: false,
  complete_loading: false,
  leave_loading: false,
  notary_details_loading: false,
  feedback_loading: false,
};
